import { byId, byClass, getViewPortHeight, getCurrentPage, smoothScrollBy, show, hide, getScrollY, getBrowser, calcPageScrollPercent } from './utils'

const pageDownContainerEl = byClass('page-down-arrow-container')
const backToTopEl = byClass('back-to-top')

function bindPageDownClick () {
  pageDownContainerEl.onclick = scrollToNextPage
  backToTopEl.onclick = backToTop
}

function scrollToNextPage () {
  let top
  // 是否倒数第二页
  let isLastTwoPage = false
  const viewPortHeight = getViewPortHeight()
  const currentPage = getCurrentPage()
  const currentPageEl = byId(currentPage)
  let nextPageEl = currentPageEl
  if (nextPageEl.parentElement) nextPageEl = nextPageEl.parentElement
  if (nextPageEl.nextElementSibling) {
    nextPageEl = nextPageEl.nextElementSibling
    if (!nextPageEl.nextElementSibling) isLastTwoPage = true
  }
  if (nextPageEl.firstElementChild) nextPageEl = nextPageEl.firstElementChild
  if (['ie', 'edge', 'safari'].includes(getBrowser())) {
    if (currentPage === 'celebrating' && calcPageScrollPercent('celebrating') < 0.5) {
      nextPageEl = byClass('yearbook') || nextPageEl
    }
    if (currentPage === 'craft-inspiration' && calcPageScrollPercent('craft-inspiration') < 0.5) {
      nextPageEl = byClass('craft-inspiration-video') || nextPageEl
    }
  }
  if (currentPage === 'yearbook' && getScrollY() < viewPortHeight / 2) {
    top = nextPageEl.getBoundingClientRect().top - viewPortHeight - 1
  } else if (currentPage === 'craft-inspiration') {
    top = nextPageEl.getBoundingClientRect().top - viewPortHeight - 1
    if (top < viewPortHeight) top = nextPageEl.getBoundingClientRect().top
  } else if (currentPageEl.getBoundingClientRect().top > 10) {
    top = currentPageEl.getBoundingClientRect().top
  } else if (isLastTwoPage) {
    // 在倒数第二页滚动时，滚动到正好显示出 footer
    top = byClass('footer').getBoundingClientRect().bottom - viewPortHeight
  } else {
    top = nextPageEl.getBoundingClientRect().top
  }
  smoothScrollBy(top, 1000)
}

function toggleBackToTop () {
  if (getScrollY() > 1000) {
    backToTopEl.classList.add('visible')
  } else {
    backToTopEl.classList.remove('visible')
  }
}

function backToTop () {
  const top = -getScrollY()
  const duration = getScrollY() / 3 < 5000 ? getScrollY() / 3 : 5000
  smoothScrollBy(top, duration)
}

function togglePageDownColor () {
  const currentPage = getCurrentPage()
  if (!byId(currentPage).parentElement.nextElementSibling) {
    // 到最后一页，隐藏 pagedown
    hide(pageDownContainerEl)
    return
  } else {
    show(pageDownContainerEl)
  }
  // 根据页面变换 pagedown 的颜色
  switch (currentPage) {
    case 'symbols':
    case 'craft-inspiration':
    case 'wear-images':
      setPageDownWhite()
      break
    case 'your':
    case 'wear-it-your-way':
    case 'keepsake-cubes':
    case 'gifts':
      setPageDownBlack()
      break
    // celebrating 和 yearbook 之间切换动画特殊，翻页按钮颜色也需要特殊处理
    default:
      return
  }
}

function setPageDownBlack () {
  pageDownContainerEl.classList.remove('white')
  pageDownContainerEl.classList.add('black')
}

function setPageDownWhite () {
  pageDownContainerEl.classList.remove('black')
  pageDownContainerEl.classList.add('white')
}

export {
  bindPageDownClick,
  togglePageDownColor,
  toggleBackToTop,
  setPageDownBlack,
  setPageDownWhite
}
